import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["data-is-open", "content"]
const _hoisted_2 = {
  class: "relative mr-0.5",
  style: {"height":"26px","width":"26px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ml-1 font-medium text-success-default" }, " Get Started ", -1)

import {
  computed, onMounted, ref,
  watch,
} from 'vue';
import { useStore } from 'vuex';
import ChecklistsPopoverContent from '@/components/checklists/ChecklistsPopoverContent.vue';
import ProgressRing from '@/components/ui/ProgressRing.vue';
import ChecklistsCloseModal from './ChecklistsCloseModal.vue';
// eslint-disable-next-line import/named
import { ChecklistStep } from '@/checklists/useChecklists';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChecklistsNavButton',
  setup(__props) {

const store = useStore();

const isOpen = computed(() => store.getters['checklists/popoverOpen']);
const url = new URL(window.location.href);
const isOnboarding = url.searchParams.has('onboarding');
const timeout = ref<number | null>(null);
const hasClosedChecklistModal = computed(() => store.getters['checklists/hasClosedChecklistModal']);
const showCloseModal = ref(false);

const progress = computed(() => {
  const steps = store.getters['checklists/steps'];

  return (steps.filter((step: ChecklistStep) => !!step.completed_at).length / steps.length) * 100;
});

onMounted(() => {
  if (isOnboarding) {
    store.commit('checklists/setPopoverOpen', true);
  }

  if (progress.value < 100 && !hasClosedChecklistModal.value) {
    store.commit('checklists/setPopoverOpen', true);
  }
  url.searchParams.delete('onboarding');
});

function toggleChecklists() {
  if (timeout.value) {
    clearTimeout(timeout.value);
  }

  store.commit('checklists/setPopoverOpen', !isOpen.value);
}

function onModalCancel() {
  showCloseModal.value = false;
  store.commit('checklists/setPopoverOpen', true);
}

function onClose() {
  // If they never closed the checklist modal before we show
  // them a dialog to ensure they're informed about it
  if (progress.value < 100 && !hasClosedChecklistModal.value) {
    showCloseModal.value = true;
    store.commit('checklists/setHasClosedChecklistModal', true);
  } else {
    showCloseModal.value = false;
    store.commit('checklists/setPopoverOpen', false);
  }
}

const tooltipContent = computed(() => `${(progress.value).toFixed(0)}% completed`);


return (_ctx: any,_cache: any) => {
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      id: "checklists-nav-button",
      class: _normalizeClass([
      // eslint-disable-next-line max-len
      'cursor-pointer items-center text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-400 bg-action-secondary text-emphasis border hover:text-emphasis h-10 p-3 rounded-lg inline-flex w-full justify-evenly gap-0 border-green-400 border-solid px-2 transition-colors hover:bg-subtle focus:outline-green-400',
      {
        'outline outline-2 outline-offset-2 outline-green-400': _unref(isOpen),
        'animate-pulse': _unref(isOnboarding)
      }
    ]),
      "data-is-open": _unref(isOpen),
      content: _unref(tooltipContent),
      onClick: toggleChecklists
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ProgressRing, {
          percentage: _unref(progress),
          "foreground-color": "#5BB97B",
          size: "24"
        }, null, 8, ["percentage"])
      ]),
      _hoisted_3
    ], 10, _hoisted_1)), [
      [_directive_tippy]
    ]),
    (_unref(isOpen))
      ? (_openBlock(), _createBlock(ChecklistsPopoverContent, {
          key: 0,
          "on-close": onClose
        }))
      : _createCommentVNode("", true),
    (showCloseModal.value)
      ? (_openBlock(), _createBlock(ChecklistsCloseModal, {
          key: 1,
          onCancel: onModalCancel,
          onClose: onClose
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})